module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/subject-healthcare-icon-ccff019ab9d7a5143c3f772889623217.svg";